import { FC } from 'react';
import { DataGrid as BaseDataGrid, FilterRow, Paging } from 'devextreme-react/data-grid';
import { GridColDef } from '@material-ui/data-grid';
import { useTranslation } from 'react-i18next';

import DataGridProgress from '../progress/DataGridProgress';
import { DataGridBatchActions } from './DataGridSelection/model/dataGridSelectionModel';
import { DataGridRow } from './model/dataGridRowModel';
import './DataGrid.scss';

interface DataGridProps {
  rows: DataGridRow[];
  columns?: GridColDef[];
  batchActions?: DataGridBatchActions[];
}

const DataGrid: FC<DataGridProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="DataGrid-container">
      <DataGridProgress />
      <BaseDataGrid dataSource={props.rows} showBorders={true} showRowLines={true} noDataText={t('data_grid.no_data')}>
        <FilterRow visible={false} />
        <Paging defaultPageSize="50" />
        {props.children}
      </BaseDataGrid>
    </div>
  );
};

export default DataGrid;
